<template>
  <div class="languageslist">
    <!-- 删除按钮及搜索框 -->
    <el-row type="flex" justify="space-between" align="middle" class="tool-tips">
      <el-col>
        <el-button type="primary" @click="newLanguage">新增语言</el-button>
        <el-button type="danger" @click="handleDeleteBatch" v-if="ids.length">批量删除</el-button>
      </el-col>
      <el-col align="right">
        <!-- 这里@keyup.enter需要加上native -->
        <el-input
          v-model="vipname"
          placeholder="关键字查询"
          class="input-with-select"
          @keyup.enter.native="handleSearch"
        >
          <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
        </el-input>
      </el-col>
    </el-row>
    <!-- 表格 -->
    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" align="center"></el-table-column>

      <el-table-column label="ID" align="center" prop="id"></el-table-column>
      <el-table-column prop="name" align="center" label="语言"></el-table-column>
      <el-table-column prop="ecode" align="center" label="代码"></el-table-column>
      <el-table-column prop="sort" align="center" label="排序"></el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <!-- 待使用elementui完善语言等eidt界面 -->
          <!-- https://element.eleme.cn/#/zh-CN/component/message-box -->
          <el-button type="primary" icon="el-icon-edit" circle  @click="handleEdit(scope.row)"></el-button>
          
          <el-button type="danger" @click="handleDelete(scope.row)" icon="el-icon-delete" circle></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[2, 4, 8, 16]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalcount"
      class="pagination"
    ></el-pagination>


    <el-dialog
      :title="editLanguage.id?'编辑语言':'新增语言'"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose">
      <el-form :inline="true" :model="editLanguage" class="demo-form-inline">
        <el-form-item label="语言">
          <el-input v-model="editLanguage.name" placeholder="语言"></el-input>
        </el-form-item>
        <el-form-item label="代码">
          <el-input v-model="editLanguage.ecode" placeholder="代码"></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input v-model="editLanguage.sort" placeholder="排序"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="editLanguageSubmit">{{editLanguage.id?'修改':'新增'}}</el-button>
        </el-form-item>
      </el-form>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span> -->
    </el-dialog>
  </div>
</template>

<script>
import { delete_languages, edit_language, get_languages } from '../api/api';

export default {
  data() {
    return {
      dialogVisible:false,
      editLanguage:{},//当前正在编辑的语言
      tableData: [],
      ids: [],
      currentPage: 1,
      pageSize: 4,
      totalcount: 0,
      orderstatus: "",
      vipname: "",
      express_fee: "",
      paymentTitle: ""
    };
  },

  methods: {
    handleSearch() {
      // 根据搜索值获取商品
      this.getLanguagesList();
    },
    // 每页条数改变的时候
    handleSizeChange(val) {
      // 重新改变每页条数
      this.pageSize = val;
      // 并重新获取数据
      this.getLanguagesList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getLanguagesList();
    },

    // 删除单行数据
    handleDelete(val) {
      // 弹窗确认框
      this.$confirm(`是否删除${val.name}?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          // 确定则发送删除请求
          //   获取id
          const { id } = val;
          delete_languages(id)
          .then(res=>{
            this.$message({
              showClose: true,
              message: `删除成功`,
              type:"success"
            })
            this.getLanguagesList()
          })
          .catch(err=>{
            this.$message({
              showClose: true,
              message: err,
              type:"error"
            })
          })
        })
        .catch(() => {
          // 取消的时候什么都不做

        });
    },
    // 批量删除
    handleDeleteBatch() {
      const ids = this.ids.join(",");
      if (!ids) {
        this.$message({
          type: "warning",
          message: "还没选择要删除的语言"
        });
        return;
      }
      
      // 弹窗确认框
      this.$confirm(`是否删除所选语言?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          // 确定则发送删除请求
          //   获取id
          delete_languages(ids)
          .then(res=>{
            this.$message({
              showClose: true,
              message: `删除成功`,
              type:"success"
            })
            this.getLanguagesList()
          })
          .catch(err=>{
            this.$message({
              showClose: true,
              message: err,
              type:"error"
            })
          })
        })
        
        .catch(() => {
          // 取消的时候什么都不做
        });
    },
    handleSelectionChange(val) {
      var ids = val.map(v => v.id);
      this.ids = ids;
    },
    getLanguagesList() {
      // 发起获取订单请求
      get_languages(this.currentPage,this.pageSize,0,this.vipname)
      .then(res=>{
         this.tableData = res.list.sort((A,B)=>{
            return A.id - B.id
         });
         this.totalcount = res.total
      })
    },
    handleEdit(scope){
      console.log('eidt',scope)
      this.editLanguage = JSON.parse(JSON.stringify(scope))
      this.dialogVisible = true
    },
    newLanguage(){
      this.editLanguage = {}
      this.dialogVisible = true
    },
    handleClose(e){
      this.editLanguage = {}
      this.dialogVisible = false
    },
    editLanguageSubmit(e){
      if(!this.editLanguage.name || !this.editLanguage.name.length){
        this.$message('语言不能为空');
        return
      }
      console.log('editLanguageSubmit',e,this.editLanguage)
      edit_language(this.editLanguage.id,this.editLanguage.name,this.editLanguage.sort,this.editLanguage.ecode)
      .then(res=>{
        this.$message({
          showClose: true,
          message: `${this.editLanguage.id?'编辑成功':'新增成功'}`,
          type:"success"
        })
        this.dialogVisible = false
        this.getLanguagesList()

      })
      .catch(err=>{
        this.$message({
          showClose: true,
          message: err,
          type:"error"
        })
      })

      // if(this.editLanguage.id){
      //   //edit
      // }else{
      //   //add
      // }
    }

  },
  mounted() {
    //   页面加载成功后获取订单列表
    this.getLanguagesList();
  }
};
</script>

<style>
.el-select .el-input {
  width: 130px;
}
.input-with-select {
  width: 50%;
}
.input-with-select .el-input-group__prepend {
  background-color: #fff;
}

.tool-tips {
  margin: 20px 0;
}

.good-img {
  width: 30%;
  padding: 0 10px;
}

.pagination {
  margin-top: 20px;
}
</style>